module.exports = __webpack_public_path__ + "static/img/4.ac516cc2.jpg";